import Vue from 'vue';
import ElementUI from "element-ui";
import { Plugin as FragmentPlugin} from 'vue-fragment';
import SvgIcon from '@/components/SvgIcon.vue';
import WatermarkCommon from '@/components/base/Watermark/WatermarkCommon.vue';

// import "element-ui/lib/theme-chalk/index.css";
import '@/assets/styles/element-variables.scss';
import '@/assets/styles/index.scss';  //公共样式
import './utils/format';
import '@/utils/auto-update'; //版本自动更新

// import VueParticles from "vue-particles";

// import "./assets/iconfont/iconfont.css"
import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(ElementUI); //注册 element-ui 组件
// Vue.use(VueParticles); //注册例子特效组件
Vue.use(FragmentPlugin);  //注册文档片段组件
Vue.component('SvgIcon', SvgIcon); //注册图标组件
Vue.component("WatermarkCommon", WatermarkCommon);  //注册公共水印组件

// Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
